function removeDuplicates(arr) {
        return arr.filter((item, index) => arr.indexOf(item) === index);
    }

    function removeBlanks(arr) {
        return arr.filter(item => item != "");
    }
    
    function handleAddToCartClick(el, event) {
      //event.preventDefault();   
      
      let allAddedProducts = localStorage.getItem('addToCartProducts')?.split(',') || [];
      var productId = parseInt((event.target.closest('form').dataset.id)?.replace('product-actions-','')) || parseInt((event.target.closest('form').getAttribute('id'))?.replace('product-form-', '')) || parseInt((event.target.closest('form').getAttribute('id'))?.replace('product-form-sticky-', ''));
      var variantId = event.target.closest('form').querySelector("select[name='id']")?.value || event.target.closest('form').querySelector("input[name='id']")?.value;
      var quantity = event.target.closest('form').querySelector("input[name='quantity']")?.value || event.target.closest('.productView-product').querySelector("input[name='quantity']")?.value;

      Shopify.getCart(function(cart) {
        var isInCart = false;
        let items = cart.items;
        for(let i=0;i<items.length;i++) {
          if (productId == items[i].product_id) {
            isInCart = true;
            break;
          }
        }
        if (isInCart) {
            setTimeout(function(){ popupMessage(window.cart_message) }, 1000);
            allAddedProducts.push(productId.toString());                  
            let filteredBlanks = removeBlanks(allAddedProducts);
            let filteredIds = removeDuplicates(filteredBlanks);
            localStorage.setItem('addToCartProducts', filteredIds.join(','));
        }         
      });
     
    }
  
   function popupMessage(message) {
      const popupDiv = document.createElement('div');
      popupDiv.className = 'popup-message_wrapper';
     
      const closeButton = document.createElement('div');
     closeButton.className="cart_message_close";
      closeButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"></path></svg>';
      closeButton.addEventListener('click', () => {
        document.body.removeChild(popupDiv);
        document.body.classList.remove('popup-message_wrapper_added');
      });
      
      const messageDiv = document.createElement('div');
      document.body.classList.add('popup-message_wrapper_added');
      messageDiv.classList.add('cart_popup_message');
      messageDiv.innerHTML = message;

      popupDiv.appendChild(closeButton);
      popupDiv.appendChild(messageDiv);
     
      popupDiv.style.position = 'fixed';
      popupDiv.style.top = '50%';
      popupDiv.style.left = '50%';
      popupDiv.style.transform = 'translate(-50%, -50%)';
      popupDiv.style.padding = '10px';
      popupDiv.style.background = 'rgba(255,255,255)';
      //popupDiv.style.color = 'red';
      popupDiv.style.borderRadius = '5px';
      popupDiv.style.zIndex = '9999';
      document.body.appendChild(popupDiv);
    }
